<template>
  <div>
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-icon v-else>fad fa-headset</v-icon>
      <v-toolbar-title class="ml-0 pl-3">Platforms</v-toolbar-title>
      <v-layout align-center style="max-width: 800px">
        <v-select
          :items="PlatformsList"
          item-text="name"
          item-value="id"
          v-model="selectedPlatform"
          label="Select a platform"
          autocomplete
          solo-inverted
          flat
          dense
          class="ml-5"
          v-if="!screenIsWideEnough"
        ></v-select>
      </v-layout>
      <v-btn color="accent" dark fab absolute bottom right @click.stop="showNewPlatform = true">
        <v-icon>add</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container fill-height fluid class="pa-0 calc-height grey lighten-2">
        <v-layout :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }">
          <v-flex class="platform-list-container" :class="{ hidden: !screenIsWideEnough }">
            <v-list class="pt-0" two-line dense v-if="PlatformsList">
              <template v-for="platform in PlatformsList">
                <v-list-item
                  :key="platform.id"
                  @click="selectPlatform(platform.id)"
                  :class="{ selected: platform.id === SelectedPlatform.id }"
                >
                  <v-list-item-content>
                    <v-list-item-title style="max-width:250px;overflow: hidden;text-overflow: ellipsis">
                      {{ platform.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider :key="`divider-${platform.id}`"></v-divider>
              </template>
            </v-list>
          </v-flex>

          <v-flex style="overflow-y:auto;min-width:905px;">
            <v-card
              flat
              :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }"
            >
              <v-tabs background-color="grey lighten-3" v-model="tabs">
                <v-tabs-slider color="accent"></v-tabs-slider>
                <v-tab key="details">Details</v-tab>
                <v-tab key="users">Users</v-tab>
              </v-tabs>
            </v-card>
            <v-tabs-items
              v-model="tabs"
              :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }"
            >
              <v-tab-item key="details">
                <v-container
                  class="pt-2 grey lighten-2"
                  :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'pl-0': $vuetify.breakpoint.width > 1600 }"
                >
                  <v-layout>
                    <v-flex xs12 sm9 md6>
                      <v-card class="pa-2">
                        <v-card-text>
                          <v-form lazy-validation>
                            <v-container grid-list-md>
                              <v-layout wrap>
                                <v-flex xs12 sm6>
                                  <v-text-field label="Platform Name" v-model="selectedPlatform.name"></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout wrap>
                                <v-flex xs12 sm6>
                                  <v-switch label="Enabled" v-model="selectedPlatform.enabled"></v-switch>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-form>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="accent" @click="updateDetails">Update</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
              <v-tab-item key="users">
                <platform-users :roles="roles"></platform-users>
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <new-platform-dialog :roles="roles" :show.sync="showNewPlatform"></new-platform-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import PlatformUsers from './PlatformUsers';
import NewPlatformDialog from './NewPlatformDialog';

export default {
  components: {
    PlatformUsers,
    NewPlatformDialog
  },
  name: 'platforms',
  data: () => ({
    showNewPlatform: false,
    search: null,
    tabs: null,
    platform: [
      {
        users: [
          {
            id: null
          }
        ]
      }
    ],
    roles: ['Platform', 'Owner', 'Call Centre', 'Content Manager', 'Content Administrator', 'Accounts']
  }),
  computed: {
    ...mapGetters(['PlatformsList', 'SelectedPlatform', 'UILeftDrawer']),
    selectedPlatform: {
      get() {
        return this.platform;
      },
      set(id) {
        this.platform = this.selectPlatform(id);
      }
    },
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    }
  },
  methods: {
    ...mapActions([
      'getPlatformsList',
      'selectPlatform',
      'updatePlatform',
      'addNotification',
      'updateUILeftDrawerState'
    ]),
    isDefined(value) {
      return !_.isUndefined(value);
    },
    updateDetails: function() {
      this.updatePlatform({
        id: this.selectedPlatform.id,
        updates: {
          name: this.selectedPlatform.name,
          enabled: this.selectedPlatform.enabled
        }
      });
    }
  },
  mounted() {
    this.getPlatformsList();
  },
  watch: {
    SelectedPlatform: function(platform) {
      this.platform = _.clone(platform);
    }
  }
};
</script>

<style lang="scss" scoped>
.full-height {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-filtered-height {
  height: calc(100vh - 267px);
  max-height: calc(100vh - 267px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.responsive {
  width: 100%;
  max-width: 135px;
  height: auto;
}

::v-deep {
  .input-group--text-field input,
  .input-group__selections__comma {
    font-size: 13px;
  }
}

::v-deep textarea {
  font-size: 13px;
}

.theme--light .input-group.input-group--solo-inverted.input-group--focused {
  background-color: #fff;

  ::v-deep input,
  ::v-deep .input-group__prepend-icon {
    color: rgba(0, 0, 0, 0.78);
  }
}

.btn-toggle--selected {
  box-shadow: none;

  .btn--active {
    color: #e91e63;

    > .btn__content:before {
      opacity: 0;
    }
  }
}

.theme--light {
  .subheader.text--accent-1 {
    color: #e91e63;
  }
  &.v-list {
    background: inherit;
  }
}

::v-deep .tabs__item--active {
  color: #2196f3;
}

.hidden {
  display: none;
}

.selected {
  background: #b08faf;
  color: white;

  .list__tile__title {
    font-weight: 600;
  }

  .list__tile__sub-title {
    color: rgba(255, 255, 255, 0.87);
  }
}
::v-deep .v-list__tile.v-list__tile--link.theme--light {
  border-radius: 0 !important;
}
.platform-list-container {
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  max-width: 280px;
  min-width: 280px;
  overflow-y: auto;
  width: 280px;
}
</style>
